// Design tokens shared by the screens and components.
export const colors = {
  primary: "#2563eb",
  primaryDark: "#1d4ed8",
  primarySoft: "#e8f0fe",
  navy: "#14213d",
  background: "#f3f5f9",
  surface: "#ffffff",
  border: "#e3e8ef",
  text: "#0f172a",
  textMuted: "#64748b",
  textFaint: "#94a3b8",
  danger: "#ef4444",
  dangerSoft: "#fef2f2",
  success: "#16a34a",
  warning: "#f59e0b",
};

export const radius = {
  small: 8,
  medium: 12,
  large: 16,
};

export const shadow = {
  card: {
    shadowColor: "#0f172a",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 3,
    elevation: 1,
  },
  raised: {
    shadowColor: "#0f172a",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.12,
    shadowRadius: 16,
    elevation: 4,
  },
};

// Items and categories store a colour name. These are the shades shown.
const ITEM_COLORS = {
  tomato: "#f2684e",
  firebrick: "#c0392b",
  blue: "#3b82f6",
  gray: "#64748b",
  green: "#16a34a",
  darkorange: "#f59e0b",
  darkmagenta: "#a855f7",
};

export function itemColor(name) {
  return ITEM_COLORS[name] || name || ITEM_COLORS.gray;
}

// colour and shape of an item or category, read from its stored value
export function colorAndShape(value) {
  let parsed = {};
  try {
    parsed = JSON.parse(value.colorAndShape)[0] || {};
  } catch (e) {
    parsed = {};
  }
  return {
    color: itemColor(parsed.color),
    shape: parsed.shape || "square",
  };
}

// "$12.50", or "12.50" when the currency symbol is switched off
export function formatMoney(value, currency, withoutSymbol) {
  const { formatNumber } = require("accounting-js");
  const MoneyCurrency = require("money-currencies");
  const amount = formatNumber(value);
  if (withoutSymbol) {
    return amount;
  }
  return new MoneyCurrency(currency ? currency : "PHP").moneyFormat(amount);
}
